import { useContext } from "react";
import { NumberFormatContext } from "./NumbeFormatContext";
import { _throw, IllegalStateError } from "shared-ts-utils-core";

export const useNumberFormat = (): Intl.NumberFormat => {
  return (
    useContext(NumberFormatContext) ??
    _throw(
      new IllegalStateError(
        "useNumberFormat must be used within a LocaleProvider"
      )
    )
  );
};
